export const downloadSpeeds = [
  20, 35, 40, 50, 100, 105, 108, 110, 112, 120, 135, 140, 141, 150, 162, 175, 180, 185, 188, 200, 210, 216, 220, 223, 225, 230, 250, 260,
  263, 292, 300, 326, 335, 336, 338, 350, 375, 380, 390, 400, 412, 430, 450, 475, 477, 480, 489, 500, 530, 548, 600, 612, 627, 640, 676,
  680, 700, 706, 740, 750, 780, 800, 877, 900, 998, 1000, 1023, 1030, 1100, 1156, 1167, 1200, 1500, 1576, 1600,
];
